import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SummaryReportComponent } from '@app/main/summary-report/summary-report.component';
import { SharedModule } from '@shared/shared.module';
import { SummaryReportRoutingModule } from './summary-report-routing.module';
import { SummaryReportViewComponent } from './components/summary-report-view/summary-report-view.component';
import { SummaryReportNewComponent } from './components/summary-report-new/summary-report-new.component';
import { SummaryReportPlaceholderComponent } from './components/summary-report-placeholder/summary-report-placeholder.component';

@NgModule({
    declarations: [
        SummaryReportComponent,
        SummaryReportViewComponent,
        SummaryReportNewComponent,
        SummaryReportPlaceholderComponent
    ],
    imports: [CommonModule, SharedModule, SummaryReportRoutingModule]
})
export class SummaryReportModule {}
